import { PiPasswordFill } from "react-icons/pi";
import { MdEmail } from "react-icons/md";
import { FaEye, FaEyeSlash, FaUser } from "react-icons/fa";
import { useState } from "react";
import { useTheme } from "../../../context/useThemeContext";
import { hexToRGBA } from "../../../utility/hexToRGB";
import styled from "styled-components";

export const LoginInput = styled.input<{ $borderColor: string }>`
    outline: 1px solid transparent;

    &:focus {
        outline: 2px solid ${(props) => props.$borderColor};
    }
`;

export function LoginField(props: {
    fieldTitle: string;
    fieldID: string;
    fieldType: React.HTMLInputTypeAttribute;
    disabled?: boolean;
    defaultValue?: string;
    value?: string;
    invalidInput?: boolean;
    errorMessage?: string;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    minLength?: number;
    disableSpaces?: boolean;
    children?: React.ReactNode;
}) {
    const { theme } = useTheme();
    const [showPassword, setShowPassword] = useState(false);

    function setType(): React.HTMLInputTypeAttribute {
        if (props.fieldType === "password" && showPassword) {
            return "text";
        } else {
            return props.fieldType;
        }
    }

    return (
        <div className="flex flex-col text-left">
            <div className="flex items-center">
                <div className="icon w-[26px]">
                    {props.fieldType === "email" && <MdEmail size={18} />}
                    {props.fieldType === "password" && (
                        <PiPasswordFill size={18} />
                    )}
                    {props.fieldType === "text" && <FaUser size={16} />}
                </div>
                <p>{props.fieldTitle}</p>
                <div className="flex flex-1"></div>
                <p className="text-sm text-red-600">{props.errorMessage}</p>
            </div>
            <div
                className="my-2 flex h-[36px] items-center rounded px-2 overflow-hidden"
                style={{
                    backgroundColor: hexToRGBA(theme.headerColor, 0.7),
                    border: "1px solid " + theme.secondaryHeaderColor,
                    opacity: props.disabled ? ".5" : "1",
                    outline: props.invalidInput
                        ? "2px solid rgb(220, 38, 38)"
                        : "transparent",

                    paddingRight: props.children ? 0 : "8x",
                }}
            >
                <LoginInput
                    $borderColor={theme.accentColor}
                    type={setType()}
                    id={`login${props.fieldID}`}
                    className="flex-1 border-0 bg-transparent outline-transparent"
                    style={{
                        outline: "2px solid transparent",
                    }}
                    disabled={props.disabled}
                    value={props.value}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        //* This doesn't fix copy and pasting. Use validation for this
                        if (props.disableSpaces && e.code === "Space") {
                            e.preventDefault();
                        }
                    }}
                    onChange={props.onChange}
                    minLength={props.minLength}
                />
                {/* Show/hide password text */}
                {props.fieldType === "password" && (
                    <div
                        className="flex justify-center items-center w-[15px] h-[15px] cursor-pointer"
                        style={{
                            color: "rgba(255, 255, 255, 0.5)",
                        }}
                        onClick={() => {
                            setShowPassword(!showPassword);
                        }}
                    >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </div>
                )}
                {props.children}
            </div>
        </div>
    );
}
